import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export interface TextFieldProps {
    name: string;
    label?: string;
    type?: 'text' | 'email' | 'tel' | 'number' | 'url';
    placeholder?: string;
    autoComplete?: string;
    autoFocus?: boolean;
    required?: boolean;
    disabled?: boolean;
    inputMode?: 'text' | 'email' | 'tel' | 'numeric';
    helpText?: string;
}

export function TextField({
    name,
    label,
    type = 'text',
    placeholder,
    autoComplete,
    autoFocus,
    required,
    disabled,
    inputMode,
    helpText,
}: TextFieldProps) {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    const { t } = useTranslation();
    const error = errors[name];
    const message = typeof error?.message === 'string' ? t(error.message) : undefined;
    const errorId = `${name}-error`;
    const helpId = `${name}-help`;
    const describedBy = error ? errorId : helpText ? helpId : undefined;

    return (
        <Form.Group className="mb-3" controlId={name}>
            {label && (
                <Form.Label>
                    {label}
                    {required && (
                        <span className="field-required-mark" aria-hidden="true">
                            *
                        </span>
                    )}
                </Form.Label>
            )}
            <Form.Control
                type={type}
                placeholder={placeholder}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                inputMode={inputMode}
                disabled={disabled}
                isInvalid={!!error}
                aria-invalid={error ? true : undefined}
                aria-describedby={describedBy}
                {...register(name)}
            />
            {helpText && !error && (
                <Form.Text id={helpId} className="text-muted">
                    {helpText}
                </Form.Text>
            )}
            <Form.Control.Feedback type="invalid" id={errorId}>
                {message}
            </Form.Control.Feedback>
        </Form.Group>
    );
}
